<template>
  <WebChapterTemplate
    page-title="“新闻与传播学术前沿”微信公号"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section">
      <article class="content-card">
        <div class="wechat-intro">
          <h2 class="section-title">“新闻与传播学术前沿”微信公号</h2>
          <p class="body-text">
            “新闻与传播研究学术前沿”微信公号于 2014 年 5 月 13 日正式开通，现有用户 3.5 万人。它持续发布新闻传播学界重要成果与动态信息，已经成为研究所面向学界和公众的重要新媒体窗口。
          </p>
        </div>

        <div class="wechat-gallery">
          <figure class="wechat-figure wechat-figure--test-open">
            <img :src="images.testOpen" alt="微信公号首次测试开通页面截图" />
            <figcaption>5 月 8 日，公号首次测试开通页面截图</figcaption>
          </figure>
          <figure class="wechat-figure wechat-figure--launch">
            <img :src="images.launch2014" alt="2014 年 5 月 13 日开通页面截图" />
            <figcaption>2014 年 5 月 13 日开通页面截图</figcaption>
          </figure>
          <figure class="wechat-figure wechat-figure--wordcloud">
            <img :src="images.wordcloud" alt="公号词云" />
            <figcaption>公号词云</figcaption>
          </figure>
          <figure class="feed-figure feed-figure--feature">
            <img :src="images.feed2018" alt="2018 年 10 月 13 日公号推送截屏" />
            <figcaption>2018 年 10 月 13 日，公号推送截屏</figcaption>
          </figure>
        </div>
      </article>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuXinwenyuchuanboxueshuqianyan',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        testOpen: require('./assets/wechat-test-open.jpg'),
        launch2014: require('./assets/wechat-launch-2014.jpg'),
        wordcloud: require('./assets/wechat-wordcloud.jpg'),
        feed2018: require('./assets/wechat-feed-2018.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.content-card {
  padding: 28px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(243, 247, 250, 0.82), rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(252, 250, 246, 0.95));
  border: 1px solid rgba(179, 145, 101, 0.18);
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 22px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.feed-figure,
.wechat-figure {
  margin: 0;
}

.feed-figure img,
.wechat-figure img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 8px 22px rgba(45, 33, 16, 0.08);
}

.feed-figure figcaption,
.wechat-figure figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

.wechat-intro {
  margin-bottom: 24px;
}

.wechat-gallery {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.9fr) minmax(240px, 0.72fr);
  gap: 20px;
  align-items: start;
  grid-template-areas:
    'testOpen launch feed'
    'testOpen wordcloud feed';
}

.wechat-figure--test-open {
  grid-area: testOpen;
}

.wechat-figure--launch {
  grid-area: launch;
}

.wechat-figure--wordcloud {
  grid-area: wordcloud;
}

.feed-figure--feature {
  grid-area: feed;
}

.feed-figure--feature img,
.wechat-figure--test-open img {
  width: 100%;
}

@media (max-width: 1024px) {
  .wechat-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas:
      'feed feed'
      'testOpen launch'
      'wordcloud wordcloud';
  }

  .feed-figure--feature img {
    max-width: 280px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .portal-grid,
  .wechat-gallery {
    grid-template-columns: 1fr;
    grid-template-areas:
      'feed'
      'testOpen'
      'launch'
      'wordcloud';
  }

  .content-card {
    padding: 18px;
  }
}
</style>
